import React, { Component } from 'react';
import { MessageCircle, Phone } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function FloatingButtons() {
  const {
    lang
  } = useLanguage();
  const msg = lang === 'es' ? '¿Cuándo es el próximo taller de constelaciones?' : 'Quan és el proper taller de constel·lacions?';
  const waLink = `https://wa.me/34671636887?text=${encodeURIComponent(msg)}`;
  return <div className="fixed bottom-5 right-5 z-[9999] flex flex-col gap-4" data-id="element-243">
      <a href="tel:671636887" className="w-14 h-14 bg-gold text-white rounded-full flex items-center justify-center shadow-[0_4px_15px_rgba(0,0,0,0.3)] hover:scale-110 transition-transform duration-300" aria-label="Llamar por teléfono" data-id="element-244">
        <Phone className="w-6 h-6" data-id="element-245" />
      </a>

      <a id="whatsapp-float" href={waLink} target="_blank" rel="noopener noreferrer" className="w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-[0_4px_15px_rgba(0,0,0,0.3)] hover:scale-110 transition-transform duration-300 animate-[pulse_2s_infinite]" aria-label="Contactar por WhatsApp" data-id="element-246">
        <MessageCircle className="w-6 h-6" data-id="element-247" />
      </a>
    </div>;
}